import { showAuthErrorToast } from '@/composables/toast'
import store from '@/store'


export default function useAuth() {
  const login = (username, password, twoFAEnabled) => {
    return store
      .dispatch('auth/basicLogin',{ username, password, useTwoFAAuth: twoFAEnabled })
      .catch(err => {
        const statusCode = err.message.response.status
        let text = 'Не удалось войти в систему'
        if (err.message.response && err.message.response.status === 403) {
          text = err.message.response.data && err.message.response.data.users_session_limit
            ? err.message.response.data.users_session_limit : err.message.response.data.detail
        } else if (err.message.response && err.message.response.status === 401) {
          text = err.message.response.data.detail
        } else if (err.message.response) {
          text = 'Неправильный логин или пароль'
        }
        showAuthErrorToast(text, statusCode)
      })
  }
  const logout = reason => store.dispatch('auth/logout', reason)

  return {
    login,
    logout,
  }
}